// src/redux/slices/aboutSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const BASE_URL = 'https://evercorenutrition.com/ev_admin/api';

// Async thunk for fetching about us data
export const fetchAboutUs = createAsyncThunk(
  'about/fetchAboutUs',
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${BASE_URL}/about/`);
      return response.data; // Returns array of about sections
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const initialState = {
  sections: [],           // All about sections from API
  ourStory: null,         // Section with title "Our Story"
  qualityCommitment: null, // Section with title "Our Quality Commitment"
  ourTeam: null,          // Section with title "Meet Our Team"
  status: 'idle',
  error: null,
};

const aboutSlice = createSlice({
  name: 'about',
  initialState,
  reducers: {
    clearAboutData: (state) => {
      state.sections = [];
      state.ourStory = null;
      state.qualityCommitment = null;
      state.ourTeam = null;
      state.status = 'idle';
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAboutUs.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(fetchAboutUs.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.sections = action.payload;
        
        // Find specific sections by title
        state.ourStory = action.payload.find(section => 
          section.title.toLowerCase().includes('story')
        ) || null;
        
        state.qualityCommitment = action.payload.find(section => 
          section.title.toLowerCase().includes('quality')
        ) || null;
        
        state.ourTeam = action.payload.find(section => 
          section.title.toLowerCase().includes('team')
        ) || null;
      })
      .addCase(fetchAboutUs.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload || 'Failed to fetch about us data';
      });
  },
});

export const { clearAboutData } = aboutSlice.actions;

// Selectors
export const selectAboutSections = (state) => state.about.sections;
export const selectOurStory = (state) => state.about.ourStory;
export const selectQualityCommitment = (state) => state.about.qualityCommitment;
export const selectOurTeam = (state) => state.about.ourTeam;
export const selectAboutStatus = (state) => state.about.status;
export const selectAboutError = (state) => state.about.error;

export default aboutSlice.reducer;